import List from './list/Watchlist';

export default { List };
